import { useContext } from "react"
import { Route, Routes, MemoryRouter, Navigate } from "react-router";
import './App.css'
import './AppRoutes/Journal/Journal.css'
import { GLAuthContext, AuthServiceProvider, GetAuthServices } from "./Services/AuthService/AuthService.tsx";
import { Journal, JournalRouteFragment } from "./AppRoutes/Journal/Journal.tsx";
import urlJoin from "url-join";
import { LoginPage } from "./UI Components/Pages/LoginPage/LoginPage.tsx";
import { appInsights } from "./Services/AppInsightsService.tsx";
import { LandingPage } from "./AppRoutes/Landing/LandingPage.tsx";
import { DataServices } from "./Services/DataService/DataService.ts";
import React from "react";

var setInitialized: React.Dispatch<React.SetStateAction<boolean>> | undefined;
GetAuthServices().then((authServices) => {
  authServices.userChanged.Subscribe(() => {

    if (!authServices.IsLoggedIn()) {
      DataServices.Raw.ClearCaches();
      setInitialized && setInitialized(false);
    }
    else {
      let shouldAwait = DataServices.IsNewCache();
      let promise = DataServices.Initialize(shouldAwait);

      promise.then(() => setInitialized &&
        setInitialized(true));
    }
  });
});


function App2() {

  const [isInitialized, setIsInitialized] = React.useState(false);
  setInitialized = setIsInitialized;

  appInsights!.fireAppLaunch();
  const authContext = useContext(GLAuthContext);

  if (window.location.href.indexOf('landing') >= 0) {
    return <LandingPage />;
  }
  else {

    if (!isInitialized || !authContext?.isLoggedIn)
      return <LoginPage />;

    return (
      <div style={{ width: "100%", height: "100%" }}>
        <MemoryRouter>
          <Routes>
            {
              (!authContext?.isLoggedIn)
                ? <Route path="*" element={<LoginPage />} />
                :
                <>
                  <Route path={urlJoin("", JournalRouteFragment, "*")} Component={Journal} />
                  <Route path="*" element={<Navigate to='/journal/home' />} />
                </>
            }
          </Routes>
        </MemoryRouter>
      </div>
    )
  }
}

export function App() {
  return (
    <AuthServiceProvider>
      <App2 />
    </AuthServiceProvider>
  );
}

